// Homepage content lives in one structured file so it can move to the CMS (Phase 4+) without touching components.
export const HERO = {
  eyebrow: "Technology · Software · Digital Growth",
  lines: ["Build smarter.", "Scale faster.", "Grow beyond limits."],
  highlightLine: 2, // index of the line that takes the gradient treatment
  sub: "From custom software and digital products to intelligent marketing strategies, we help ambitious businesses build, grow and compete in a digital-first world.",
  primaryCta: { label: "Book a free discovery call", to: "/contact" },
  secondaryCta: { label: "Explore our services", to: "/services" },
};

export const MARQUEE_ITEMS = [
  "Software Development",
  "Web Applications",
  "SaaS Products",
  "Mobile Apps",
  "AI Integration",
  "SEO",
  "Digital Growth",
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "Discover",
    text: "A focused discovery call and technical scoping session. We map your goals, users, constraints and the fastest path to value before a line of code is written.",
  },
  {
    step: "02",
    title: "Design & Define",
    text: "Wireframes, architecture and a delivery plan you can actually read. Every screen and every sprint is agreed up front — no surprises mid-build.",
  },
  {
    step: "03",
    title: "Build & Launch",
    text: "Iterative development with weekly demos and a staging environment you can inspect at any time. Launch is a checklist, not a leap of faith.",
  },
  {
    step: "04",
    title: "Grow & Optimise",
    text: "Post-launch support, performance monitoring and growth engineering — SEO, GEO and conversion optimisation layered onto a product that was built for it.",
  },
];

export const INDUSTRIES = [
  "SaaS & Technology",
  "E-commerce & Retail",
  "Professional Services",
  "Healthcare & Wellness",
  "Real Estate & Property",
  "Education & Training",
  "Hospitality & Travel",
  "Trades & Local Services",
];

export const CONCEPT_PROJECTS = [
  {
    name: "Meridian Ops",
    kind: "SaaS Operations Platform",
    label: "Concept Project",
    summary:
      "A multi-tenant operations dashboard concept: role-based views, live pipeline metrics and audit trails — our reference architecture for serious B2B SaaS.",
    tags: ["React", "FastAPI", "Multi-tenant", "Dashboards"],
    image:
      "https://images.unsplash.com/photo-1637166185518-058f5896a2e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyHxmdXR1cmlzdGljJTIwY29kZSUyMEFJJTIwc29mdHdhcmUlMjBhcmNoaXRlY3R1cmUlMjBkYXJrJTIwdGhlbWV8ZW58MHx8fHwxNzkzNzUyMjU1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "PulseField",
    kind: "AI Support Automation",
    label: "Concept Project",
    summary:
      "An AI-assisted support desk concept that triages enquiries, drafts replies in the brand voice and escalates the conversations that need a human.",
    tags: ["AI Integration", "Chatbots", "Workflow Automation"],
    image:
      "https://images.unsplash.com/photo-1518773553398-650c184e0bb3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxmdXR1cmlzdGljJTIwY29kZSUyMEFJJTIwc29mdHdhcmUlMjBhcmNoaXRlY3R1cmUlMjBkYXJrJTIwdGhlbWV8ZW58MHx8fHwxNzkzNzUyMjU1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Atlas Commerce",
    kind: "Headless E-commerce Build",
    label: "Demonstration",
    summary:
      "A headless storefront demonstration: sub-second catalogue browsing, editorial content zones and a checkout flow engineered for conversion.",
    tags: ["E-commerce", "Headless", "Performance", "CRO"],
    image:
      "https://images.pexels.com/photos/8134609/pexels-photo-8134609.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    name: "Halo Health",
    kind: "Mobile App Experience",
    label: "Concept Project",
    summary:
      "A cross-platform wellness app concept exploring calm UI, offline-first syncing and appointment flows designed around real patient behaviour.",
    tags: ["iOS", "Android", "UI/UX", "Offline-first"],
    image:
      "https://images.pexels.com/photos/33433724/pexels-photo-33433724.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const INTRO = {
  eyebrow: "Who we are",
  title: "A technology partner first — a growth engine always.",
  paragraphs: [
    "A2Z Rankings is an international technology, software development and digital growth agency. We design and build custom software, web platforms, SaaS products, mobile apps and AI-powered automation — then we make sure the market can find them.",
    "Our team works with Australian businesses as our primary market, alongside clients in India, the USA, the UK, Canada and beyond. Technology is roughly seventy per cent of what we do; digital marketing is the multiplier we apply once the product deserves it.",
  ],
};
